module.exports = __webpack_public_path__ + "static/img/CandyBag.8edad831.png";